import { computed } from 'vue';
<!-- A section with a title -->
<!-- FUTURE: Make this rely on external CSS classes to customize -->
<script lang="ts" setup>
    import { computed } from 'vue';

    const props = defineProps<{
        title?: string
    }>();

    const displayedTitle = computed<string>(() =>{
        return props.title ?? "Section";
    });
</script>

<style scoped>
 .section-fieldset
 { 
     border: 1px solid lightgray; 
     margin-bottom: 1em; 
     border-radius: 0.25em; 
     padding: 0.5em;   
 }

 .section-fieldset:hover
 {
     background-color: ghostwhite;
     border: 1px solid slategray; 
 }
</style>

<template>
    <fieldset class="section-fieldset">
        <legend style="color:slategray" v-if="title">{{displayedTitle}}</legend>
        <slot></slot>
    </fieldset>
</template>